import type { ArrayFieldTemplateItemType } from '@rjsf/utils';
import clsx from 'clsx';
import React, { cloneElement } from 'react';

const ArrayFieldItemTemplate = ({
	disabled,
	readonly,
	onDropIndexClick,
	children,
	className,
	registry,
	hasRemove,
	index,
	uiSchema,
}: ArrayFieldTemplateItemType) => {
	const { RemoveButton } = registry.templates.ButtonTemplates;

	return (
		<div data-role="ArrayFieldItemTemplate" className={clsx(className, 'flex flex-row')}>
			{cloneElement(children, { className: 'flex-1', isArrayItem: true }, null)}

			{hasRemove && (
				<div className={clsx('self-start mt-1 shrink-0')}>
					<RemoveButton
						disabled={disabled || readonly}
						onClick={onDropIndexClick(index)}
						uiSchema={uiSchema}
						registry={registry}
					/>
				</div>
			)}

			{/* {items.length - 1 !== idx && (
					<div
						key={`${key}-divider`}
						data-role={'ArrayFieldTemplateItemDivider'}
						style={{ height: 1, backgroundColor: '#E4E8F0' }}
					/>
				)} */}
		</div>
	);
};

export { ArrayFieldItemTemplate };
